import { useCallback, useEffect, useMemo } from 'react';
import { HashRouter } from 'react-router-dom';
import cx from 'classnames';

import { useLandingScrollToHash } from './hooks/useLandingInitialScrollPos';

import useBreakpointValue from 'hooks/useBreakpointValue';
import ClaimYourPiece from './components/sections/ClaimYourPiece';
import UltimatePhysicalNFT from './components/sections/UltimatePhysicalNFT';
import Artists from './components/sections/Artists';
import TheCards from './components/sections/TheCards';
// import CollectionBreakdown from './components/sections/CollectionBreakdown'
import Features from './components/sections/Features';
import ExoticMythic from './components/sections/ExoticMythic';

import SubscribeModal from './components/SubscribeModal';
import AnchoredSection from './components/AnchoredSection';
import AnimateEnter from './components/AnimateEnter';

import appLogo from 'assets/logos/full_logo.svg';

import Text from 'shared_components/Text';
import { EthIcon } from 'shared_components/SVGIcons';

import epicsLogo from 'assets/logos/epics_logo.svg';
import styles from './styles.module.scss';
import TopSalesBlock from 'shared_containers/TopSalesBlockHome';

const sectionProps = { className: styles.sectionContent };

declare global {
  interface Window {
    displayPreferenceModal: () => void;
  }
}

const Landing = () => {
  const openCookiePrefs = useCallback(() => {
    window?.displayPreferenceModal();
  }, []);

  const cardColumnsCount = useBreakpointValue({
    // 2100: 5,
    1500: 7,
    1200: 5,
    960: 5,
    740: 5,
    480: 2,
    0: 2,
  });

  const columnsStyles = useMemo(
    () =>
      ({
        '--cardColumnCount': cardColumnsCount,
      } as React.CSSProperties),
    [cardColumnsCount]
  );

  // useEffect(() => {
  //   // Show/hide top nav when scrolling
  //   const nav = document.querySelector('header');
  //   const resetNavStyles = (nav: HTMLElement) => {
  //     nav.style.opacity = '1';
  //     nav.style.transform = 'translateY(0px)';
  //   };
  //   const handleScrollPos = () => {
  //     if (nav) {
  //       const page = document.documentElement || document.body;
  //       const isSmallScreen = window.innerWidth < 10,
  //         scrolledDown = page.scrollTop > lastScrollTop,
  //         scrolledUp = !scrolledDown;

  //       if (
  //         Boolean(isSmallScreen ? scrolledUp : true) &&
  //         page.scrollTop > window.innerHeight / 20
  //       ) {
  //         // show nav
  //         resetNavStyles(nav);
  //       } else if (
  //         Boolean(isSmallScreen ? scrolledDown : false) ||
  //         (page.scrollTop === 0 && nav.style.opacity === '1')
  //       ) {
  //         // hide nav
  //         nav.style.transform = 'translateY(0px)';
  //       }
  //       lastScrollTop = page.scrollTop;
  //     }
  //   };
  //   window.addEventListener('scroll', handleScrollPos, { passive: true });
  //   window.dispatchEvent(new Event('scroll'));
  //   return () => {
  //     if (nav) resetNavStyles(nav);
  //     window.removeEventListener('scroll', handleScrollPos);
  //   };
  // }, []);

  //useLandingScrollToHash();

  //

  return (
    <div className={cx(styles.landing, 'full-bleed')}>
      {/* bg */}
      {/* <div className={styles.landingBackground}>
        <img
          src={background}
          alt="landing background"
          aria-hidden={true}
          onLoad={({ currentTarget }) =>
            void (currentTarget.style.opacity = '1')
          }
        />
      </div> */}

      {/* <div className={styles.mainLogo}>
          <img alt="logo" src={appLogo} className={styles.mainAppLogo} />
        </div> */}

      <AnchoredSection id="history">
        <ClaimYourPiece {...sectionProps} />
      </AnchoredSection>

      {/* <AnchoredSection id="sales">
        <AnimateEnter>
          <div className={styles.topSales}>
            <TopSalesBlock
              defaultRange="alltime"
              className={styles.topBlock}
              headerClassName={styles.topBlockHeader}
              style={columnsStyles}
            />
          </div>
        </AnimateEnter>
      </AnchoredSection> */}

       {/*<HashRouter hashType="noslash">
        <AnchoredSection id="nft">
          <AnimateEnter>
            <UltimatePhysicalNFT {...sectionProps} />
          </AnimateEnter>
        </AnchoredSection>
        <AnchoredSection id="exoticMythic">
          <AnimateEnter>
            <ExoticMythic {...sectionProps} />
          </AnimateEnter>
        </AnchoredSection>
        <AnchoredSection id="artists" className={styles.theArtists}>
          <AnimateEnter>
            <Artists {...sectionProps} />
          </AnimateEnter>
        </AnchoredSection>
        <AnchoredSection id="cards">
          <AnimateEnter>
            <TheCards {...sectionProps} />
          </AnimateEnter>
        </AnchoredSection>

        <AnchoredSection id="collections">
          <AnimateEnter>
            // <CollectionBreakdown {...sectionProps} />
          </AnimateEnter>
        </AnchoredSection>
        <AnchoredSection id="features">
          <AnimateEnter>
            <Features {...sectionProps} />
          </AnimateEnter>
        </AnchoredSection>
      </HashRouter>*/}

      {/* <Text className={styles.poweredBy} as="p">
        <strong>Proudly Powered by</strong>{' '}
        <EthIcon size={window.innerWidth > 900 ? 24 : 14} />
      </Text> */}

      {/* <footer>
        <div className={styles.inner}>
          <div className={styles.logoContainer}>
            <a href="https://epics.gg/" target="_blank" rel="noreferrer">
              <img src={epicsLogo} alt="logo" />
            </a>
          </div>
          <div className={styles.textContainer}>
            <Text className={styles.text} as="h3" size="base">
              Empowering Millions
            </Text>
            <Text className={styles.text} as="p" size="sm">
              Already empowering over 140,000,000 unique digital collectibles in
              partnership with some of the top game publishers, esports leagues
              and influencers in the world.
            </Text>
          </div>
          <div className={styles.textContainer}>
            <a
              className={styles.doNotSell}
              href="https://app.termly.io/notify/7a685322-a806-40d0-bb89-51369f668c3d"
              target="_blank"
              rel="noreferrer"
            >
              Do not sell my info
            </a>{' '}
            <button onClick={openCookiePrefs} className={styles.doNotSell}>
              Manage Cookie Preferences
            </button>
          </div>
        </div>
      </footer> */}

      <SubscribeModal />
    </div>
  );
};

export default Landing;
